import React from 'react';

export function Link(address: string, description: string | undefined = undefined) {
  return (
    <a href={address} target="_blank" rel="noopener noreferrer">
      {description ?? address}
    </a>
  );
}
